<div class="container">
    <!-- Mostrar cuando hay productos en el carrito O cuando está recargando -->
    <div *ngIf="(carritoCompras[0] && carritoCompras[0].length > 0) || isReloading" class="cart-header-section">
      <div class="cart-header-top">
        <div class="cart-header-info">
          <h6 class="cart-header-title">
            <i class="fas fa-shopping-cart"></i>
            Mi Carrito
            <span class="badge bg-danger ms-2" *ngIf="!isReloading">{{ carritoCompras[0].length }}</span>
            <span class="badge bg-danger ms-2" *ngIf="isReloading">
              <i class="fas fa-spinner fa-spin"></i>
            </span>
          </h6>
        </div>
        <button class="btn-descuentos-header" (click)="abrirPopupDescuentos()" title="Ver descuentos por volumen">
          <i class="fas fa-percent"></i>
          <span>Descuentos</span>
        </button>
        <button class="btn-clear-cart" (click)="limpiarCarrito()" title="Vaciar carrito" [disabled]="isReloading">
          <i class="fas fa-trash"></i>
        </button>
      </div>

      <div class="cart-subtotal">
        <ng-container *ngIf="!isLoadingCart && !isReloading">
          <span class="subtotal-label">Subtotal:</span>
          <span class="subtotal-amount">{{monedaCarrito}} {{precioTotal | number:'1.2-2'}}</span>
        </ng-container>
        <ng-container *ngIf="isLoadingCart || isReloading">
          <i class="fas fa-spinner fa-spin"></i>
          <span class="ms-2">Calculando...</span>
        </ng-container>
      </div>

      <div class="cart-divider"></div>
    </div>

    <!-- Mensaje cuando el carrito está vacío (y NO está recargando) -->
    <div *ngIf="!isLoadingCart && !isReloading && (!carritoCompras[0] || carritoCompras[0].length === 0)" class="empty-cart-header-container">
      <div class="empty-cart-header-message">
        <div class="empty-cart-header-icon">
          <i class="fas fa-shopping-cart"></i>
        </div>
        <p class="empty-cart-header-title">Tu carrito está vacío</p>
        <p class="empty-cart-header-description">Explora nuestra colección</p>
        <div class="empty-cart-header-actions">
          <a [routerLink]="['/fotografias']" class="btn-explore-header btn-primary-header">
            <i class="fas fa-camera"></i>
            <span>Fotografías</span>
          </a>
          <a [routerLink]="['/portadas']" class="btn-explore-header btn-secondary-header">
            <i class="fas fa-newspaper"></i>
            <span>Portadas</span>
          </a>
        </div>
      </div>
    </div>

    <div class="cart-items-container" *ngIf="(carritoCompras[0] && carritoCompras[0].length > 0) || isReloading">
        <div *ngFor="let libro of carritoCompras[0]; let i = index" class="cart-item-card">
          <!-- Mostrar skeleton si el item está cargando -->
          <div *ngIf="isItemLoading(i)" class="cart-item-skeleton-container">
            <div class="cart-item-layout">
              <div class="cart-item-image-wrapper">
                <app-image-skeleton
                  width="100%"
                  height="100%"
                  size="small">
                </app-image-skeleton>
              </div>
              <div class="cart-item-info" style="flex: 1;">
                <div class="skeleton-line" style="width: 80%; height: 16px; margin-bottom: 8px;"></div>
                <div class="skeleton-line" style="width: 60%; height: 14px; margin-bottom: 8px;"></div>
                <div class="skeleton-line" style="width: 40%; height: 14px;"></div>
              </div>
            </div>
          </div>

          <!-- Mostrar contenido real cuando el item ha cargado -->
          <ng-container *ngIf="!isItemLoading(i) && libro">
            <div class="cart-item-badge">
              <span class="item-number">#{{i + 1}}</span>
            </div>

            <div class="cart-item-layout">
              <!-- Imagen -->
              <div class="cart-item-image-wrapper">
                <ng-container *ngIf="libro.activoId">
                  <img *ngIf="getProtectedImageUrl(libro.activoId)"
                       [src]="getProtectedImageUrl(libro.activoId)"
                       class="cart-item-img"
                       alt="{{libro.lista[0].title}}">
                  <div *ngIf="shouldShowSkeleton(libro.activoId)" class="cart-item-skeleton">
                    <app-image-skeleton
                      width="100%"
                      height="100%"
                      size="small">
                    </app-image-skeleton>
                  </div>
                </ng-container>
                <img *ngIf="!libro.activoId"
                     [src]="libro.lista[0].thumbnail ? (imagen(libro.lista[0].thumbnail) + tokenImagen) : libro.lista[0].image"
                     class="cart-item-img"
                     alt="{{libro.lista[0].title}}">
              </div>

              <!-- Información del producto -->
              <div class="cart-item-info">
                <h6 class="cart-item-title">{{ libro.lista[0].title }}</h6>
                <p class="cart-item-modality">
                  <i class="fas fa-tag"></i>
                  {{ obtenerModalidad(libro.lista[0], carritoDetalle.lista[i].modalidadId) }}
                </p>
                <div class="cart-item-price">
                  {{ obtenerMoneda(libro.lista[0], carritoDetalle.lista[i].modalidadId) }} {{ obtenerPrecio(libro.lista[0], carritoDetalle.lista[i].modalidadId) }}
                </div>
              </div>

              <!-- Botón eliminar -->
              <div class="cart-item-actions">
                <button class="btn-delete-item"
                        (click)="feliminarCarrito(i)"
                        title="Eliminar producto">
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
      

    <div class="row w-100" *ngIf="(carritoCompras[0] && carritoCompras[0].length > 0) || isReloading">
        <div class="col-sm-12 p-3">
            <button class="btn btn-carrito" (click)="verCarrito()" [disabled]="isReloading">
              <span *ngIf="!isReloading">Ver Carrito</span>
              <span *ngIf="isReloading">
                <i class="fas fa-spinner fa-spin me-2"></i>
                Actualizando...
              </span>
            </button>
        </div>
    </div>
</div>
